/*
 * assets/ce-header.js — <ce-header>
 *
 * Einzige Aufgabe: der Scroll-Zustand der Nav-Kapsel (01-design-spec.md §5.11/§6.1,
 * 02-theme-architecture.md §3.5). Ersetzt den Scroll-Listener des Exports (Z. 374–382)
 * durch einen IntersectionObserver auf ein Sentinel — gleiches Ergebnis, aber kein
 * Handler im Main Thread bei jedem Scroll-Frame.
 *
 * Das Sentinel ist so hoch wie die Umschaltschwelle (Setting `scroll_threshold`,
 * Z. 377) und steht als absolut positioniertes Element am Dokumentanfang, also
 * ausserhalb der haftenden Leiste — sonst wanderte es mit und verliesse den
 * Viewport nie. Die Hoehe kommt als --ce-sentinel-h aus Liquid, damit sie schon
 * vor dem ersten Frame stimmt.
 *
 * Ohne JavaScript bleibt die Kapsel im Ruhezustand (deckend weiss). Das ist der
 * serverseitig gerenderte Zustand (state.scrolled = false, Design-Spec §7.4) und
 * damit ein vollstaendig gueltiger Endzustand — Progressive Enhancement.
 */

class CEHeader extends window.CE.Element {
  setup(signal) {
    this.shell = this.querySelector('.ce-navshell');
    if (!this.shell) return;

    // auto | light | frosted (Export-Prop headerZustand, Z. 362)
    const mode = this.opt('state', 'auto');

    if (mode !== 'auto') {
      // Fest eingestellt: einmal setzen, kein Beobachter, kein Listener.
      this.shell.classList.toggle('is-frosted', mode === 'frosted');
      return;
    }

    const threshold = this.opt('threshold', 40);
    const sentinel = this.querySelector('.ce-header__sentinel');

    if (sentinel && 'IntersectionObserver' in window) {
      this._io = new IntersectionObserver(
        ([entry]) => {
          this.shell.classList.toggle('is-frosted', !entry.isIntersecting);
        },
        { threshold: 0 }
      );
      this._io.observe(sentinel);
      return;
    }

    // Fallback: passiver Scroll-Listener wie im Export. `signal` raeumt ihn
    // im disconnectedCallback der Basisklasse automatisch ab.
    const onScroll = () => {
      this.shell.classList.toggle('is-frosted', window.scrollY > threshold);
    };
    addEventListener('scroll', onScroll, { passive: true, signal });
    onScroll();
  }

  /** Wird von CEElement.disconnectedCallback aufgerufen. */
  teardown() {
    this._io?.disconnect();
    this._io = null;
  }
}

customElements.define('ce-header', CEHeader);
